import {
  browserGetConnectUrlForProvider,
  browserGetProfile,
  browserShowSignIn,
  browserShowSignOut,
  ensureBrowserAuthBootstrap,
  getAuthProvider,
  getBrowserAuthAccessToken,
} from '../browser-auth'
import type { BrowserFallbackRegistry } from './types'

export const authBrowserFallbacks: BrowserFallbackRegistry = {
  auth: {
    getAccessToken: async () => {
      await ensureBrowserAuthBootstrap()
      return await getBrowserAuthAccessToken()
    },
    getAuthProvider: async () => {
      await ensureBrowserAuthBootstrap()
      return getAuthProvider()
    },
    signOut: () => browserShowSignOut(),
    showSignIn: (payload) => {
      const screenHint = payload === 'sign-in' || payload === 'sign-up' ? payload : undefined
      return browserShowSignIn(screenHint)
    },
    showSignOut: () => browserShowSignOut(),
    getConnectUrlForProvider: (payload) => {
      const provider = typeof payload === 'string' ? payload : (payload?.provider ?? '')
      const options = typeof payload === 'string' ? undefined : payload?.options
      return browserGetConnectUrlForProvider(provider, options)
    },
  },
  workos: {
    getAccessToken: async () => {
      await ensureBrowserAuthBootstrap()
      return await getBrowserAuthAccessToken()
    },
    showSignIn: (payload) => {
      const screenHint = payload === 'sign-in' || payload === 'sign-up' ? payload : undefined
      return browserShowSignIn(screenHint)
    },
    showSignOut: () => browserShowSignOut(),
    getProfile: () => browserGetProfile(),
  },
}
